import React, {useEffect, useRef, useState} from 'react';
import TextField from "@material-ui/core/TextField";
import {useTranslation} from "react-i18next";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import './ConditionForm.css';
import ChipInput from "material-ui-chip-input";
import {conditionalOperators} from '../../../../helpers/helper';
import {useRecoilState} from "recoil";
import {selectedField} from "../../../../recoil-store/recoil-state";

export default function ConditionForm({fields, setConditionField, index, setFocusedSourceInput, focusedSourceInput}) {
    const [chips, setChips] = useState([])
    const [conditionOperations, setConditionOperations] = useState([]);
    const [targetAvailable, setTargetAvailable] = useState(false);
    const [selectedFieldValue, setSelectedFieldValue] = useRecoilState(selectedField);

    const ref = useRef(null);
    const {t} = useTranslation();
    const label = "GENERAL.CONDITION."

    const chipConfig = {
        "text": "text",
        "value": "value",
        "type": "type"
    }


    const commonConditionalOperators = [conditionalOperators.eq, conditionalOperators.neq, conditionalOperators.e, conditionalOperators.ne];

    const setFieldValue = (key, val, index) => {
        setConditionField(key, val, index);
        targetChecker(val, chips[index]);
    }

    const targetChecker = (val, chip) => {
        if (val === "e" || val === "ne") return setTargetAvailable(false);
        setTargetAvailable(true);
    }

    const conditionalOperatorPatterns = (type) => {
        const patterns = {
            "string": [...commonConditionalOperators, conditionalOperators.ct, conditionalOperators.nct, conditionalOperators.sw, conditionalOperators.nsw, conditionalOperators.ew, conditionalOperators.new],
            "number": [...commonConditionalOperators, conditionalOperators.ct, conditionalOperators.nct, conditionalOperators.gt, conditionalOperators.lt, conditionalOperators.sw, conditionalOperators.nsw, conditionalOperators.ew, conditionalOperators.new],
            "date": [...commonConditionalOperators, conditionalOperators.ct, conditionalOperators.nct, conditionalOperators.gt, conditionalOperators.lt, conditionalOperators.sw, conditionalOperators.nsw, conditionalOperators.ew, conditionalOperators.new],
            "object": [...commonConditionalOperators, conditionalOperators.ct, conditionalOperators.nct],
            "boolean": [...commonConditionalOperators]
        }

        return patterns[type];
    }

    useEffect(() => {
        if (fields?.source?.length) {
            setChips(fields?.source);
            //const chipValueSplit = fields.source[0].value.split('::');
            // setConditionOperations(conditionalOperatorPatterns(chipValueSplit[0]))
            setConditionOperations(conditionalOperatorPatterns(fields.source[0].type))
        }

        targetChecker(fields?.condition);

        if (document.activeElement === ref.current) {
            console.log(ref.current)
        }

    }, [])

    // useEffect(() => {
    //     setConditionField('source', chips, index);
    // }, [chips]);

    useEffect(() => {
        if (selectedFieldValue.path.length) {
            handleAddChip({
                "text": selectedFieldValue.name,
                "value": selectedFieldValue.path,
                "type": selectedFieldValue.type
            })
            setSelectedFieldValue({
                name: '',
                type: '',
                path: []
            })
        }
    }, [selectedFieldValue]);

    const handleAddChip = (chip) => {
        if (index === focusedSourceInput && chips.filter(x => x.value.includes(chip.value)).length === 0) {
            setChips([...chips, chip])
            setConditionField('source', [...chips, chip], index);
            setConditionOperations(conditionalOperatorPatterns(chip.type))
        }
    }

    const handleClickSource = (index) => {
        setFocusedSourceInput(index);
    }

    const handleDeleteChip = (chip) => {
        let currentChips = JSON.parse(JSON.stringify(chips));
        currentChips = currentChips.filter((c) => c.value !== chip.value);
        setChips(currentChips);
        setConditionField('source', currentChips, index);
    }

    return (
        <>
            <div className="form-element">
                {t(label + "TRIGGER-DATA")}
                <ChipInput
                    ref={ref}
                    inputProps={{style: {fontSize: 15, height: 20, paddingLeft: 15}}}
                    fullWidth
                    className="input"
                    autoFocus
                    color="primary"
                    dataSourceConfig={chipConfig}
                    variant="outlined"
                    value={chips}
                    onClick={(e) => handleClickSource(index)}
                    onAdd={(chip) => handleAddChip(chip)}
                    onDelete={(chip, index) => handleDeleteChip(chip)}
                />
            </div>
            <div className="form-element">
                {t(label + "CONDITION-TYPE")}
                <FormControl
                    variant="outlined"
                    style={{width: "100%"}}
                >
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        style={{
                            backgroundColor: "#fff",
                            height: "41px",
                            fontSize: "15px",
                            paddingLeft: 15
                        }}
                        disabled={!chips.length}
                        id="demo-simple-select-outlined"
                        value={fields?.condition}
                        onChange={(e) => setFieldValue('condition', e.target.value, index)}
                    >
                        {conditionOperations?.length > 0 &&
                            conditionOperations?.map((item, index) => (
                                <MenuItem
                                    style={{fontSize: 12}}
                                    key={index}
                                    value={item.value}
                                >
                                    {item.text}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </div>
            <div className={`form-element ${targetAvailable ? "visible" : "hidden"}`}>
                {t(label + "TARGET-VALUE")}
                <TextField
                    onClick={(e) => handleClickSource(-1)}
                    id="filled-size-small"
                    value={targetAvailable ? fields?.target : ""}
                    onChange={(e) => setConditionField('target', e.target.value, index)}
                    className="input"
                    variant="outlined"
                    size="small"
                    inputProps={{style: {fontSize: 15, height: 20, paddingLeft: 15}}}
                />
            </div>
        </>
    );
}
